import React from "react";
import { motion } from "framer-motion";

function NoMatch() {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-100 px-4">
      {/* Animated SVG Illustration */}
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="w-72 md:w-96 mb-6"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 500 500"
          fill="none"
          className="w-full h-auto"
        >
          <circle cx="250" cy="250" r="200" fill="#f87171" />
          <text
            x="50%"
            y="50%"
            dominantBaseline="middle"
            textAnchor="middle"
            fontSize="48"
            fill="white"
            fontFamily="sans-serif"
          >
            404
          </text>
        </svg>
      </motion.div>

      {/* Animated Text */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        className="text-center"
      >
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-3">
          Page Not Found
        </h2>
        <p className="text-gray-600 text-lg mb-4">
          Sorry, we couldn't find what you were looking for.
        </p>
        <a
          href="/"
          className="mt-4 inline-block px-6 py-3 bg-red-500 text-white font-semibold rounded-xl hover:bg-red-600 transition"
        >
          Go to Home
        </a>
      </motion.div>
    </div>
  );
}

export default NoMatch;
